<template>
  <div class="order-wrapper">
    <h2 class="order-title">
      <span class="title color_40 font_w_b">全部订单</span>
      <div class="f_14 color_blue invoice cursor_p" @click="downLoadInvoice()">开增值税普通发票</div>
    </h2>

    <div class="order-content" v-loading="isLoading">

      <div :class="['order-item',{'h90': item.plan === 'hot_and_top'}]" v-for="(item, index) in orderList" :key="index">

        <div class="order-column date">
          <div class="order-column-header">{{ item.created_at }}</div>
          <div class="order-column-body">{{ typeMap[item.plan] }}</div>
        </div>

        <div class="order-column post">
          <div class="order-column-header">职位名称</div>
          <div class="order-column-body column">
            <!-- 标题 -->
            <span v-if="item.plan === 'hot' || item.plan === 'top' || item.plan === 'hot_and_top'">{{ item.job_post }}</span>
            <span v-else-if="item.plan.includes('job_refresh')">职位刷新{{ item.plan && item.plan.slice(item.plan.length-2).replace(/_/g,'') }}次</span>
            <span v-else>查看电话{{ item.plan && item.plan.slice(item.plan.length-2).replace(/_/g,'') }}次</span>

            <!-- 内容  -->
            <span v-if="item.plan === 'hot'">{{ item.status === 'paid' ? `有效期：${item.hot_start_time} 至 ${!!item.deadline ? item.deadline : moment(item.hot_start_time).add(29, 'd').format('YYYY-MM-DD')}` : '职位发布后有效期为30天' }}</span>
            <span v-else-if="item.plan === 'top'">{{ `曝光时间：${item.start_time} 至 ${moment(item.start_time).add(6, 'd').format('YYYY-MM-DD')}` }}</span>
            <span v-else-if="item.plan === 'hot_and_top'">
              <p>{{ `曝光时间：${item.start_time} 至 ${moment(item.start_time).add(6, 'd').format('YYYY-MM-DD')}` }}</p>
              {{ item.status === 'paid' ? `有效期：${item.hot_start_time} 至 ${!!item.deadline ? item.deadline : moment(item.hot_start_time).add(29, 'd').format('YYYY-MM-DD')}` : '职位发布后有效期为30天' }}
            </span>
            <span v-else-if="item.plan.includes('job_refresh')">刷新职位更新时间，当天内提升曝光</span>
            <span v-else>直接获取候选人联系方式</span>
          </div>
        </div>

        <div class="order-column order">
          <div class="order-column-header">订单号</div>
          <div class="order-column-body">{{ item.token }}</div>
        </div>

        <div class="order-column price">
          <div class="order-column-header">价格</div>
          <div class="order-column-body">￥ {{ item.price/100 }}</div>
        </div>

        <div class="order-column status">
          <div class="order-column-header">状态</div>

          <div class="order-column-body column order-placed" v-if="item.status === 'order_placed'">
            <span @click="toPay(item)">去付款</span>
            <span @click="toCancel(item)">取消订单</span>
          </div>

          <div class="order-column-body" v-else-if="item.status === 'paid'">
            订单已完成
          </div>

          <div class="order-column-body" v-else-if="item.status === 'invalid_order'">
            订单取消
          </div>

          <div class="order-column-body" v-else-if="item.status === 'refund '">
            已退款
          </div>
        </div>

      </div>
      <div class="on-order" v-if="orderList.length == 0">
        <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
        <div class="noorder-text">暂无订单信息</div>
      </div>
    </div>

    <div class="order-footer" v-if="totalCount > 6">
      <el-pagination
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="size"
        @current-change="currentChange">
      </el-pagination>
    </div>

    <!-- 发布火爆职位支付弹窗 -->
    <job-pay-dialog v-if="payDialogVisible"
                    :type="payDialogOption.type"
                    :payType="payDialogOption.payType"
                    :title="payDialogOption.title"
                    :subtitle="payDialogOption.subtitle"
                    :tipsText="payDialogOption.tipsText"
                    :orderTypeText="payDialogOption.orderTypeText"
                    :orderPriceText="payDialogOption.orderPriceText"
                    :orderToken="payDialogOption.orderToken"
                    @paidFunc="paidFunc"
                    @closeFunc="closeFunc" />

    <!-- 取消订单二次确认弹窗 -->
      <confirm-dialog v-if="confirmDialogVisible"
                      tipsTitle="取消订单"
                      tipsText="是否要取消当前订单？"
                      confirmButtonText="确认"
                      cancelButtonText="取消"
                      @confirmFunc="confirmFunc"
                      @cancelFunc="cancelFunc" />

  </div>
</template>

<script>
import moment from 'moment'
import actions from '@/actions/index'
import jobPayDialog from '@/components/block/JobPayDialog'
import confirmDialog from '@/components/block/TipsBlock'


export default {
  data () {
    return {
      moment,
      orderList: [], // 订单列表
      totalCount: 0, // 订单总数
      page: 1, // 当前页数
      size: 6, // 一页的个数
      cancelOrderToken: null, // 当前要取消的订单 token
      isLoading: false, // 正在加载
      confirmDialogVisible: false, // 是否显示取消订单弹窗
      payDialogVisible: false, // 是否显示支付弹窗
      refreshPayDialogVisible: false, // 职位刷新弹框
      payDialogOption: { // 支付弹窗的配置参数
        type: 'pay',
        payType: null,
        orderToken: null,
        title: null,
        subtitle: null,
        tipsText: null,
        orderTypeText: null,
        orderPriceText: null
      },
      typeMap: {
        hot: '火爆职位',
        top: '精准曝光',
        hot_and_top: '火爆职位 + 精准曝光',
        view_phone_3: '查看电话',
        view_phone_10: '查看电话',
        view_phone_20: '查看电话',
        view_phone_30: '查看电话',
        view_phone_50: '查看电话',
        job_refresh_10: '职位刷新',
        job_refresh_5: '职位刷新',
      },
      refreshCountPrice: {
        job_refresh_10: 180,
        job_refresh_5: 100,
      },
      phoneCountPrice: {
        view_phone_3: 90,
        view_phone_10: 300,
        view_phone_20: 480,
        view_phone_30: 675,
        view_phone_50: 1050,
      }
    }
  },
  components: {
    jobPayDialog,
    confirmDialog
  },
  created () {
    this.getOrderList()
  },
  methods: {
    // 确认取消订单回调
    confirmFunc () {
      this.cancelOrder()
      this.confirmDialogVisible = false
    },
    // 不取消订单回调
    cancelFunc () {
      this.confirmDialogVisible = false
    },
    // 去付款按钮
    toPay (orderData) {

      this.payDialogOption.orderToken = orderData.token

      if (orderData.plan === 'hot') {
        this.payDialogOption.payType = 'bJobHot'
        this.payDialogOption.title = '火爆职位'
        this.payDialogOption.subtitle = `有效期：${ moment().format('YYYY-MM-DD') } 至 ${ moment().add(30, 'd').format('YYYY-MM-DD') }`
        this.payDialogOption.tipsText = '火爆职位：该类职位HR竞争较为激烈，需要付费发布，该类产品为数字化商业产品，一经售出不支持退款退货'
        this.payDialogOption.orderTypeText = '火爆职位'
        this.payDialogOption.orderPriceText = 99
      } else if (orderData.plan === 'top') {
        this.payDialogOption.payType = 'bJobTop'
        this.payDialogOption.title = '精准曝光'
        this.payDialogOption.subtitle = '登顶同类职位榜首，增强职位曝光'
        this.payDialogOption.tipsText = '该类产品为数字化商业产品，一经售出不支持退款退货，为不影响推荐效果，购买后不建议更换职位类别'
        this.payDialogOption.orderTypeText = '精准曝光'
        this.payDialogOption.orderPriceText = 199
      } else if (orderData.plan.includes('view_phone')) {
        this.payDialogOption.payType = 'bPhone'
        this.payDialogOption.title = '查看电话'
        this.payDialogOption.subtitle = '无需等待候选人同意邀约，可直接查看心仪候选人联系方式'
        this.payDialogOption.tipsText = '该类产品为数字化商业产品，一经售出不支持退款退货'
        this.payDialogOption.orderTypeText = '查看电话'
        this.payDialogOption.orderPriceText = this.phoneCountPrice[orderData.plan]
      } else if (orderData.plan === 'hot_and_top') {
        this.payDialogOption.payType = 'bHotAndTop'
        this.payDialogOption.title = '火爆职位+精准曝光'
        this.payDialogOption.subtitle = '发布火爆职位同时购买精准曝光，享受超值优惠'
        this.payDialogOption.tipsText = '该类产品为数字化商业产品，一经售出不支持退款退货，为不影响推荐效果，购买后不建议更换职位类别'
        this.payDialogOption.orderTypeText = '火爆职位+精准曝光'
        this.payDialogOption.orderPriceText = 239
      }  else if (orderData.plan.includes('job_refresh')) {
        this.payDialogOption.payType = 'bJobRefresh'
        this.payDialogOption.title = '职位刷新'
        this.payDialogOption.orderTypeText = '职位刷新'
        this.payDialogOption.subtitle = '刷新后可大大增加职位曝光度，候选人更容易看见哦～'
        this.payDialogOption.tipsText = '该类产品为数字化商业产品，一经售出不支持退款退货'
        this.payDialogOption.orderPriceText = this.refreshCountPrice[orderData.plan]
      }

      this.payDialogVisible = true

    },
    // 去取消订单按钮
    toCancel (orderData) {
      this.cancelOrderToken = orderData.token
      this.confirmDialogVisible = true
    },
    // 取消订单
    async cancelOrder () {
      try {
        let res = await actions.recruit_infos.delete_order(this.cancelOrderToken)
        if (res.code === 1000) {
          this.$message({
            message: '取消成功',
            type: 'success'
          })
          this.getOrderList()
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 支付成功的回调
    paidFunc () {
      // this.$message.success('支付成功')
      this.payDialogVisible = false
      // 重新获取订单列表
      this.getOrderList()
    },
    // 关闭支付弹窗的回调
    closeFunc () {
      this.payDialogVisible = false
    },
    // 切换页时
    currentChange (page) {
      // 改变页数
      this.page = page
      // 重新获取订单列表
      this.getOrderList()
    },
    // 获取订单列表
    async getOrderList () {
      if (this.isLoading) return false
      this.isLoading = true
      try {
        let params = {
          page: this.page,
          size: this.size
        }
        let res = await actions.recruit_infos.get_order_list(params)
        if (res.code === 1000) {
          this.orderList = res.data.result
          this.totalCount = res.data.total_count
        }
        this.isLoading = false
      } catch (e) {
        console.log(e)
        this.isLoading = false
      }
    },
    // 增值税发票/拉起客服
    downLoadInvoice(){
      let udesk_container = document.querySelector('#udesk_btn a')
      if(udesk_container!=null){
        udesk_container.click()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  @import './Index.scss';
</style>
